import { INarrative, NarrativeTypes } from './narrative';
import { IScene } from './scene';
import { IExternalReference } from './external-reference';
import { PlatformTypes} from './enums/platform-types';

export enum EpisodeTypes {
    full_episode = 'full_episode',
    clip = 'clip',
    compilation = 'compilation',
    short = 'short',
}

export interface IEpisode {
    uid: string,
    name: string,
    mediaType?: NarrativeTypes,
    platformType?: PlatformTypes,
    minAgeRating?: number,
    title?: string,
    season: number,
    numberInSeason: number,
    episodeType?: EpisodeTypes,
    description: string,
    duration?: number,
    url?: string,
    available?: boolean,
    ipLicensed?: boolean,
    comingSoon?: boolean,
    status?: string,
    enabledAt?: string,
    createdAt?: string,
    isNew?: boolean,
    audioSignatureFileName?: string,
    audioCatalogFileName?: string,
    embedable_status?: string,

    tasksAvailableForUserCount?: number,

    externalReferences?: IExternalReference[],

    narrative?: INarrative,
    scenes?: IScene[],
}
